import React, { useEffect } from 'react';

import { Button, TextLink } from '@vds/buttons';
import { Body } from '@vds/typography';
import { Grid, Row, Col } from '@vds/grids';
import { spacers } from '@vds/theme';
import Icon from '@vds/icons';
import styled from 'styled-components';
import './PendingOrder.css';
import { isMobile } from 'react-device-detect';

const PendingCol = styled(Col)`
  margin-bottom:  ${spacers.large} !important;
`;
const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 260px));
  column-gap: 12px;
  row-gap: 24px;
  justify-items: start;
  @media screen and (-ms-high-contrast: active) and (min-width: 600px) , (-ms-high-contrast: none) {
    button {
        display: inline-block;
        margin-right: 20px;
        border: 0.0625rem solid #000000;
        color: #000000;
        span {
            font-size: 0.875rem;
            font-weight: bold;
        }
    }
 }
`;
const ButtonContainerPendingPage = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 150px));
  column-gap: 12px;
  row-gap: 24px;
  justify-items: start;
  @media screen and (-ms-high-contrast: active) and (min-width: 600px) , (-ms-high-contrast: none) {
    button {
        display: inline-block;
        margin-right: 20px;
        border: 0.0625rem solid #000000;
        color: #000000;
        span {
            font-size: 0.875rem;
            font-weight: bold;
        }
    }
 }
`;
const PendingOrder = ({ PendingOrderCallback, handleBackClickEvent, isPendingOrderPage }) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        <div className="pending-order">
            {!isMobile && 
            <Grid colSizes={{ "mobile": 12, "tablet": 12, "desktop": 12 }}>
                <Row>
                    <PendingCol>
                        {/* <Title primitive="h6">This address has a pending order.</Title> */}
                        <TextLink onClick={handleBackClickEvent}>
                        {isPendingOrderPage ? <Icon name="caret-left" size="small" /> : <> </>} Back
                        </TextLink>
                    </PendingCol>
                </Row>
                <Row>
                    <PendingCol>
                        <Body primitive="p" size="medium" className="subtext">According to our records, this address has a pending order. {isPendingOrderPage ? <br/>  : <> </>}Is it yours?</Body>
                    </PendingCol>
                </Row>
                <Row>
                    <PendingCol>
                   { !isPendingOrderPage ? 
                        (<ButtonContainer>
                            <Button secondary={true} size="large" width="260px" onClick={() => PendingOrderCallback(true)} >Yes</Button>
                            <Button secondary={true} size="large" width="260px" onClick={() => PendingOrderCallback(false)}>No</Button>
                        </ButtonContainer>) :
                        (<ButtonContainerPendingPage>
                            <Button secondary={true} size="large"   width="150px" onClick={() => PendingOrderCallback(true)} >Yes</Button>
                            <Button secondary={true} size="large"   width="150px"onClick={() => PendingOrderCallback(false)}>No</Button>
                        </ButtonContainerPendingPage>)}
                    </PendingCol>
                </Row>
            </Grid> }
            {isMobile && 
                    <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }} colGutter={false}>
                        <Row>
                    <PendingCol>
                        {/* <Title primitive="h6">This address has a pending order.</Title> */}
                        <TextLink onClick={handleBackClickEvent}>
                            {isPendingOrderPage ? <Icon name="caret-left" size="small" /> : <> </>} Back
                        </TextLink>
                    </PendingCol>
                </Row>
                <Row>
                    <PendingCol>
                        <Body primitive="p" size="medium">According to our records, this address has a pending order. Is it yours?</Body>
                    </PendingCol>
                </Row>
                    <Row className="action-mb">
                        <Col colSizes={{ mobile: 1, tablet: 5, desktop: 4 }}>        
                            <div className="continue-btn">
                            <Button secondary={true} size="large" width="260px" onClick={() => PendingOrderCallback(true)} >Yes</Button>
                            </div>
                        </Col>       
                        <Col colSizes={{ mobile: 1, tablet: 5, desktop: 4 }}>
                            <div className= "continue-btn">
                            <Button secondary={true} size="large" width="260px" onClick={() => PendingOrderCallback(false)}>No</Button>          
                            </div>
                        </Col>
                    </Row>
                </Grid> }
        </div>
    );
};

export default PendingOrder;